import { styled } from 'styled-components';

import { Box } from '#/components/Box/Box';
import { Icon } from '#/components/Icon/Icon';
import { useI18n } from '#/i18n/hooks/useI18n';

export const SearchContextHeaderLinkText = styled(
  ({ text = 'previous', className }: { text: string; className?: string }) => {
    const { i18n } = useI18n();

    return (
      <Box display="flex" alignItems="center" className={className}>
        {(() => {
          switch (text) {
            case 'next':
              return (
                <>
                  <span>{i18n('Next')}</span>
                  <Icon name="chevron-right" size={15} />
                </>
              );

            case 'previous':
            default:
              return (
                <>
                  <Icon name="chevron-left" size={15} />
                  <span>{i18n('Previous')}</span>
                </>
              );
          }
        })()}
      </Box>
    );
  },
)`
  > :not(:first-child) {
    margin-left: 5px;
  }

  svg {
    path,
    polyline {
      fill: currentcolor;
    }
  }
`;
